import React from 'react';
import { useAuthStore } from '../store';
import '../styles/pending.css';

const PendingPage = ({ onLogout }) => {
  const user = useAuthStore((state) => state.user);

  return (
    <div className="pending-root">
      <div className="pending-card">
        <div className="pending-icon">⏳</div>
        <h1 className="pending-title">Заявка на рассмотрении</h1>
        <p className="pending-text">
          Ваш аккаунт <strong>{user?.email}</strong> зарегистрирован и ожидает подтверждения администратора.
        </p>
        <p className="pending-sub">
          Обычно это занимает несколько часов. После одобрения вы сможете войти заново.
        </p>
        <button className="pending-logout" onClick={onLogout}>
          Выйти
        </button>
      </div>
    </div>
  );
};

export default PendingPage;
